import actionTypes from 'redux/actions/actionTypes'

const defaultState = {
	current: {
		folderUID: 0,
		name: '',
		color: '',
		libraryUID: 0,
		lessons: [],
		folders: [],
		parents: [],
		settings: {
			name: '',
			users_can_add: '0',
			library_type: '',
			entity_type: '',
			total_entities: 0,
			multipleSchools: false,
			banners: {},
		},
		name_folder_modal: {
			folderUID: 0,
			productUid: '',
			productType: '',
			value: '',
			status: '',
			message: '',
		},
		search: {
			focus: false,
			component: {
				open: false,
				input_keyword: '',
				selected_filters: [],
			},
			query: {
				applied_keyword: '',
				applied_filters: [],
				order_field: 'date',
				order_type: 'desc',
			},
			page: 0,
			more: true,
		},
		preserve_search: false,
		loading: false,
		init: true,
	},
	isAdmin: true,
	cache: {},
	filter_definitions: null,
	find_lessons: {
		search: {
			component: {
				open: false,
				input_keyword: '',
				selected_filters: [],
			},
			query: {
				applied_keyword: '',
				applied_filters: [],
				order_field: 'relevance',
				order_type: 'desc',
			},
			page: 0,
			more: false,
		},
		lessons: [],
		selected_lessons: [],
		show_selected: false,
		total_entities_found: 0,
		total_has_paid_lessons: false,
		selected_all: false,
		active: false,
		loading: false,
		status: 0,
	},
	name_folder_modal: {
		folderUID: 0,
		value: '',
		status: '',
		message: '',
	},
	preview: {
		entity_ID: 0,
		entity_type: '',
		infoOpen: false,
	},
}

function initializeLibraryBase(state, action) {
	const newState = {...state}
	newState.current = {...state.current}
	newState.current.libraryUID = action.libraryUID
	return newState
}

function initializeFolder(state, action) {
	const newState = initializeLibraryBase(state, action)
	if (newState.current.preserve_search) {
		const newSearch = {...state.current.search}
		newSearch.more = true
		newSearch.page = 0
		newState.current.search = newSearch
		newState.current.init = true
		newState.current.preserve_search = false
	} else {
		newState.current.search = {...defaultState.current.search}
	}
	newState.current.folderUID = action.folderUID
	newState.current.loading = true
	return newState
}

function setLibraryLessons(state, action) {
	const newArrayElements = action.entities.map(b => b.data.entityUID)
	const newState = {...state}
	const newCurrent = {...state.current}
	if (action.page === '0') {
		newCurrent.lessons = newArrayElements
	} else {
		const filteredElements = newArrayElements.filter(element => newCurrent.lessons.indexOf(element) < 0)
		newCurrent.lessons = [...newCurrent.lessons, ...filteredElements]
	}
	newCurrent.init = false
	newCurrent.loading = false
	newState.current = newCurrent
	const newSearch = {...newCurrent.search}
	newSearch.page = parseInt(action.page) + 1
	newSearch.more = action.more
	newCurrent.search = newSearch
	return newState
}

function setLibrarySettings(state, action) {
	const newState = {...state}
	const current = {...state.current}
	current.settings = action.settings
	newState.current = current
	return newState
}

function setLibrarySettingsPreserveMultipleSchools(state, action) {
	const newState = {...state}
	const current = {...state.current}
	current.settings = action.settings
	current.settings.multipleSchools = state.current.settings.multipleSchools
	newState.current = current
	return newState
}

function initializePreview(state, action) {
	const newState = {...state}
	newState.current = {...state.current}
	newState.current.libraryUID = action.libraryUID
	return newState
}

function showPrivateLibraryLessonsOverlay(state) {
	const newState = {...state}
	const newFind_lessons = {...defaultState.find_lessons}
	newFind_lessons.active = true
	newState.find_lessons = newFind_lessons
	return newState
}

function hidePrivateLibraryLessonsOverlay(state) {
	const newState = {...state}
	const newFind_lessons = defaultState.find_lessons
	newState.find_lessons = newFind_lessons
	return newState
}

function updateSearchQuery(state, action) {
	const newState = {...state}
	const newFindLessons = {...state.find_lessons}
	const newSearch = {...state.find_lessons.search}
	newSearch.more = true
	newSearch.page = 0
	const newQuery = {...newSearch.query}
	newQuery.keyword = action.keyword
	newFindLessons.search = newSearch
	newState.find_lessons = newFindLessons
	return newState
}

function setSearchResult(state, action) {
	const newArrayElements = action.entities.map(b => b.data.entityUID)
	const newState = {...state}
	const newFindLessons = {...state.find_lessons}
	if (action.page === 0) {
		newFindLessons.lessons = newArrayElements
	} else {
		const filteredElements = newArrayElements.filter(element => newFindLessons.lessons.indexOf(element) < 0)
		newFindLessons.lessons = [...newFindLessons.lessons, ...filteredElements]
	}
	newFindLessons.total_entities_found = action.total_entities_found
	newFindLessons.total_has_paid_lessons = action.total_has_paid_lessons
	newFindLessons.status = 1
	newFindLessons.loading = false
	newFindLessons.search = {...newFindLessons.search, ...{page: action.page + 1, more: action.more}}
	newState.find_lessons = newFindLessons
	return newState
}

function toggleSearchItem(state, action) {
	const newState = {...state}
	const newFindLessons = {...state.find_lessons}
	let newSelectedLessons
	const indexItem = state.find_lessons.selected_lessons.indexOf(action.id)
	if (indexItem !== -1) {
		newSelectedLessons = [...state.find_lessons.selected_lessons.slice(0, indexItem), ...state.find_lessons.selected_lessons.slice(indexItem + 1)]
	} else {
		newSelectedLessons = [...state.find_lessons.selected_lessons]
		newSelectedLessons.push(action.id)
	}
	newFindLessons.selected_lessons = newSelectedLessons
	newState.find_lessons = newFindLessons
	return newState
}

function serFilterDefinitions(state, action) {
	const newState = {...state}
	newState.filter_definitions = {...action.data}
	return newState
}

function toggleFilterSelection(state, action, context) {
	const newState = {...state}
	newState[context] = {...state[context]}
	newState[context].search = {...state[context].search}
	newState[context].search.component = {...state[context].search.component}

	const selected_filters = [...state[context].search.component.selected_filters]
	const index = selected_filters.indexOf(action.entityUID)
	if (index === -1) {
		selected_filters.push(action.entityUID)
	} else {
		selected_filters.splice(index, 1)
	}
	newState[context].search.component.selected_filters = selected_filters

	return newState
}

function clearSearch(state, action, context) {
	const newState = {...state}
	newState[context] = {...state[context]}
	newState[context].search = {...state[context].search}
	newState[context].search.page = 0
	newState[context].search.more = true
	newState[context].search.component = {...state[context].search.component}
	newState[context].search.query = {...state[context].search.query}
	newState[context].search.component.input_keyword = ''
	newState[context].search.component.selected_filters = []
	//newState[context].search.component.open = false
	newState[context].search.query.applied_keyword = ''
	newState[context].search.query.applied_filters = []

	if (context === 'find_lessons') {
		newState[context].selected_lessons = []
		newState[context].status = 0
	} else {
		newState[context].loading = true
	}

	return newState
}

function searchInputChange(state, action, context) {
	const newState = {...state}
	newState[context] = {...state[context]}
	newState[context].search = {...state[context].search}
	newState[context].search.component = {...state[context].search.component}
	newState[context].search.component.input_keyword = action.value
	return newState
}

function applySearch(state, action, context) {
	const newState = {...state}
	newState[context] = {...newState[context]}
	newState[context].search = {...state[context].search}
	newState[context].search.query = {...state[context].search.query}
	newState[context].search.page = 0
	newState[context].search.more = true
	newState[context].search.component = {...state[context].search.component}

	newState[context].search.query.applied_keyword = state[context].search.component.input_keyword
	newState[context].search.query.applied_filters = [...state[context].search.component.selected_filters]
	newState[context].search.component.open = false

	if (context === 'find_lessons') {
		newState[context].selected_lessons = []
	}
	newState[context].loading = true

	return newState
}

function toggleFiltersModal(state, action, context) {
	const newState = {...state}
	newState[context] = {...state[context]}
	newState[context].search = {...state[context].search}
	newState[context].search.component = {...state[context].search.component}
	newState[context].search.component.open = !state[context].search.component.open
	return newState
}

function toggleShowSelected(state) {
	const newState = {...state}
	newState.find_lessons = {...state.find_lessons}
	newState.find_lessons.show_selected = !newState.find_lessons.show_selected
	return newState
}

function toggleSelectAll(state) {
	const newState = {...state}
	newState.find_lessons = {...state.find_lessons}
	newState.find_lessons.selected_all = !newState.find_lessons.selected_all
	return newState
}

function updateSort(state, action, context) {
	const newState = {...state}
	newState[context] = {...state[context]}
	newState[context].search = {...state[context].search}
	newState[context].search.query = {...state[context].search.query}
	newState[context].search.query.order_type = action.order_type
	newState[context].search.query.order_field = action.order_field
	newState[context].search.page = 0
	newState[context].search.more = true
	if (context === 'find_lessons') {
		newState[context].selected_lessons = []
	}
	return newState
}

function findLessonsEntititesSaved(state, action) {
	let newState = hidePrivateLibraryLessonsOverlay(state, action)
	newState = resetPageAndMore(newState)
	newState.current.search = {...newState.current.search}
	//newState.current.search.more = false
	newState.current.search.query = {...newState.current.search.query, ...{order_field: 'date', order_type: 'desc'}}
	return newState
}

function nameFolderInputChange(state, action) {
	const newState = {...state}
	newState.name_folder_modal = {...state.name_folder_modal}
	newState.name_folder_modal.status = ''
	newState.name_folder_modal.message = ''
	newState.name_folder_modal.value = action.value
	return newState
}

function nameFolderError(state, action) {
	const newState = {...state}
	newState.name_folder_modal = {...state.name_folder_modal}
	newState.name_folder_modal.status = 'error'
	newState.name_folder_modal.message = action.message
	return newState
}

function nameFolderCancel(state) {
	const newState = {...state}
	newState.name_folder_modal = {...defaultState.name_folder_modal}
	return newState
}

function nameFolderSuccess(state, action) {
	const newState = {...state}
	newState.current = {...state.current}
	newState.current.folders = [...action.data.folders]
	newState.current.name = action.data.name
	newState.name_folder_modal = {...defaultState.name_folder_modal}
	return newState
}

function updateFolders(state, action) {
	const newState = {...state}
	newState.current = {...state.current}
	if (state.current.folderUID === 0) {
		newState.current.name = ''
	} else {
		newState.current.color = action.color
		const currentFolder = state.current.folders.find(folder => folder.id === state.current.folderUID)
		if (state.current.folders.length === 0 || (!currentFolder || currentFolder.name !== action.name)) {
			newState.current.name = action.name
		} else {
			newState.current.name = currentFolder.name
		}
	}
	if (action.parents) {
		newState.current.parents = [...action.parents]
	} else {
		newState.current.parents = [...defaultState.current.parents]
	}
	newState.isAdmin = action.isAdmin
	newState.current.folders = [...action.folders]
	return newState
}

function openNewFolderModalWithEntity(state, action) {
	const newState = {...state}
	newState.name_folder_modal = {...defaultState.name_folder_modal}
	newState.name_folder_modal.productUid = action.productUid
	newState.name_folder_modal.productType = action.productType
	return newState
}

function openRenameFolderModal(state) {
	const newState = {...state}
	newState.name_folder_modal = {...defaultState.name_folder_modal}
	newState.name_folder_modal.folderUID = state.current.folderUID
	newState.name_folder_modal.value = state.current.name
	return newState
}

function deleteCurrentFolderSuccess(state, action) {
	const newState = resetPageAndMore(state)
	newState.current.folders = [...action.data.folders]
	return newState
}

function resetPageAndMore(state) {
	const newState = {...state}
	const newCurrent = {...state.current}
	const newSearch = {...state.current.search}
	newSearch.page = 0
	newSearch.more = true
	newCurrent.search = newSearch
	newState.current = newCurrent
	return newState
}

function removeLessonFromList(state, action) {
	const newState = resetPageAndMore(state)
	const newLessons = [...state.current.lessons.filter(lesson => action.entity.entityUID!==lesson)]
	newState.current.lessons = newLessons
	return newState
}

function focusFilters(state) {
	const newState = {...state}
	newState.current = {...state.current}
	newState.current.search = {...state.current.search}
	newState.current.search.focus = true
	return newState
}

function focusFiltersClear(state) {
	const newState = {...state}
	newState.current = {...state.current}
	newState.current.search = {...state.current.search}
	newState.current.search.focus = false
	return newState
}

function togglePreviewInfo(state) {
	const newState = {...state}
	newState.preview = {...state.preview}
	newState.preview.infoOpen = !state.preview.infoOpen
	return newState
}

function setPreserveSearchFlag(state) {
	const newState = {...state}
	newState.current = {...state.current}
	newState.current.preserve_search = true
	return newState
}

function resetSwitchLibraryInputs(state) {
	const newState = {...state}
	newState.switch_library_modal = {...state.switch_library_modal}
	newState.switch_library_modal = {...defaultState.switch_library_modal}
	return newState
}

function setContentPackageQueryOrderField(state) {
	const newState = {...state}
	newState.current = {...state.current}
	newState.current.search = {...state.current.search}
	newState.current.search.query = {...state.current.search.query}
	newState.current.search.query.order_field = 'orden'
	return newState
}

function moveLesson(state, action) {
	const newState = {...state}
	newState.current = {...state.current}

	const lessonIndex = newState.current.lessons.indexOf(action.sourceUID)
	if (lessonIndex !== -1) {
		newState.current.lessons = [...state.current.lessons.slice(0, lessonIndex),
			...state.current.lessons.slice(lessonIndex + 1)]
	}

	const folderIndex = newState.current.folders.findIndex(folder => folder.id === action.targetFolderID)
	if (folderIndex !== -1) {
		const newFolder = {...newState.current.folders[folderIndex]}
		newFolder.presentationsCount += action.presentationsCount
		newState.current.folders = [...state.current.folders.slice(0, folderIndex), newFolder,
			...state.current.folders.slice(folderIndex + 1)]
	}

	return newState
}

function moveFolder(state, action) {
	const newState = {...state}
	newState.current = {...state.current}

	const sourceIndex = newState.current.folders.findIndex(folder => folder.id === action.sourceFolderID)
	if (sourceIndex !== -1) {
		newState.current.folders = [...state.current.folders.slice(0, sourceIndex),
			...state.current.folders.slice(sourceIndex + 1)]
	}

	const targetIndex = newState.current.folders.findIndex(folder => folder.id === action.targetFolderID)
	if (targetIndex !== -1) {
		const newFolder = {...newState.current.folders[targetIndex]}
		newFolder.presentationsCount += action.presentationsCount
		newState.current.folders = [...newState.current.folders.slice(0, targetIndex), newFolder,
			...newState.current.folders.slice(targetIndex + 1)]
	}

	return newState
}

function updateFolderUID(state, action) {
	return {
		...state,
		current: {
			...state.current,
			folderUID: action.folderId,
		},
	}
}

const privateLibraryReducer = (state = defaultState, action) => {
	switch (action.type) {
		case actionTypes.PRIVATE_LIBRARY_INITIALIZE_FOLDER:
			return initializeFolder(state, action)
		case actionTypes.PRIVATE_LIBRARY_LESSONS_SORT_UPDATE:
			return updateSort(state, action, 'current')
		case actionTypes.PRIVATE_LIBRARY_INITIALIZE_PREVIEW:
			return initializePreview(state, action)
		case actionTypes.PRIVATE_LIBRARY_LESSONS_FETCHED:
			return setLibraryLessons(state, action)
		case actionTypes.PRIVATE_LIBRARY_SETTINGS_FETCHED:
			return setLibrarySettings(state, action)
		case actionTypes.PRIVATE_LIBRARY_SETTINGS_SUCCESS:
			return setLibrarySettingsPreserveMultipleSchools(state, action)
		case actionTypes.PRIVATE_LIBRARY_FILTER_DEFINITIONS_FETCHED:
			return serFilterDefinitions(state, action)
		case actionTypes.PRIVATE_LIBRARY_FIND_LESSONS_MODAL_OPEN:
			return showPrivateLibraryLessonsOverlay(state, action)
		case actionTypes.PRIVATE_LIBRARY_FIND_LESSONS_MODAL_CLOSE:
			return hidePrivateLibraryLessonsOverlay(state, action)
		case actionTypes.PRIVATE_LIBRARY_SEARCH_QUERY_UPDATE:
			return updateSearchQuery(state, action)
		case actionTypes.PRIVATE_LIBRARY_SEARCH_FETCHED:
			return setSearchResult(state, action)
		case actionTypes.PRIVATE_LIBRARY_SEARCH_TOGGLE_ITEM:
			return toggleSearchItem(state, action)
		case actionTypes.PRIVATE_LIBRARY_SEARCH_SORT_UPDATE:
			return updateSort(state, action, 'find_lessons')
		case actionTypes.PRIVATE_LIBRARY_CURRENT_TOGGLE_FILTER_SELECTION:
			return toggleFilterSelection(state, action, 'current')
		case actionTypes.PRIVATE_LIBRARY_CURRENT_CLEAR_SEARCH:
			return clearSearch(state, action, 'current')
		case actionTypes.PRIVATE_LIBRARY_CURRENT_SEARCH_INPUT_CHANGE:
			return searchInputChange(state, action, 'current')
		case actionTypes.PRIVATE_LIBRARY_CURRENT_APPLY_SEARCH:
		case actionTypes.PRIVATE_LIBRARY_CURRENT_APPLY_REDIRECT_SEARCH:
			return applySearch(state, action, 'current')
		case actionTypes.PRIVATE_LIBRARY_CURRENT_TOGGLE_FILTERS_MODAL:
			return toggleFiltersModal(state, action, 'current')
		case actionTypes.PRIVATE_LIBRARY_FIND_LESSONS_TOGGLE_FILTER_SELECTION:
			return toggleFilterSelection(state, action, 'find_lessons')
		case actionTypes.PRIVATE_LIBRARY_FIND_LESSONS_CLEAR_SEARCH:
			return clearSearch(state, action, 'find_lessons')
		case actionTypes.PRIVATE_LIBRARY_FIND_LESSONS_SEARCH_INPUT_CHANGE:
			return searchInputChange(state, action, 'find_lessons')
		case actionTypes.PRIVATE_LIBRARY_FIND_LESSONS_APPLY_SEARCH:
			return applySearch(state, action, 'find_lessons')
		case actionTypes.PRIVATE_LIBRARY_FIND_LESSONS_TOGGLE_FILTERS_MODAL:
			return toggleFiltersModal(state, action, 'find_lessons')
		case actionTypes.PRIVATE_LIBRARY_FIND_LESSONS_TOGGLE_SHOW_SELECTED:
			return toggleShowSelected(state, action)
		case actionTypes.PRIVATE_LIBRARY_FIND_LESSONS_TOGGLE_SELECT_ALL:
			return toggleSelectAll(state, action)
		case actionTypes.PRIVATE_LIBRARY_FIND_LESSONS_ENTITIES_SAVED:
			return findLessonsEntititesSaved(state, action)
		case actionTypes.PRIVATE_LIBRARY_FOLDERS_FETCH_SUCCESS:
			return updateFolders(state, action)
		case actionTypes.PRIVATE_LIBRARY_NAME_FOLDER_INPUT_CHANGE:
			return nameFolderInputChange(state, action)
		case actionTypes.PRIVATE_LIBRARY_NAME_FOLDER_ERROR:
			return nameFolderError(state, action)
		case actionTypes.PRIVATE_LIBRARY_NAME_FOLDER_CANCEL:
			return nameFolderCancel(state, action)
		case actionTypes.PRIVATE_LIBRARY_NAME_FOLDER_SUCCESS:
			return nameFolderSuccess(state, action)
		case actionTypes.PRIVATE_LIBRARY_OPEN_NEW_FOLDER_MODAL_WITH_ENTITY:
			return openNewFolderModalWithEntity(state, action)
		case actionTypes.PRIVATE_LIBRARY_OPEN_RENAME_FOLDER_MODAL:
			return openRenameFolderModal(state, action)
		case actionTypes.PRIVATE_LIBRARY_DELETE_CURRENT_FOLDER_SUCCESS:
			return deleteCurrentFolderSuccess(state, action)
		case actionTypes.PRIVATE_LIBRARY_CHANGE_FOLDER_COLOR_SUCCESS:
			return updateFolders(state, action)
		case actionTypes.PRIVATE_LIBRARY_DELETE_LESSON_SUCCESS:
			return removeLessonFromList(state, action)
		case actionTypes.PRIVATE_LIBRARY_LESSONS_PICKER_ADD_SUCCESS:
		case actionTypes.PRIVATE_LIBRARY_FOLDER_ADD_LESSON_SUCCESS:
		case actionTypes.PRIVATE_LIBRARY_FOLDER_REMOVE_LESSON_SUCCESS:
		case actionTypes.PRIVATE_LIBRARY_FOLDER_MOVE_LESSON_SUCCESS:
			return resetPageAndMore(state)
		case actionTypes.PRIVATE_LIBRARY_FOCUS_FILTERS:
			return focusFilters(state)
		case actionTypes.PRIVATE_LIBRARY_FOCUS_FILTERS_CLEAR:
			return focusFiltersClear(state)
		case actionTypes.PRIVATE_LIBRARY_TOGGLE_INFO:
			return togglePreviewInfo(state)
		case actionTypes.PRIVATE_LIBRARY_PRESERVE_LIBRARY_SEARCH:
			return setPreserveSearchFlag(state)
		case actionTypes.PRIVATE_LIBRARY_SWITCH_LIBRARY:
			return resetSwitchLibraryInputs(state)
		case actionTypes.PRIVATE_LIBRARY_INITIALIZE_CONTENT_PACKAGE:
			return setContentPackageQueryOrderField(state)
		case actionTypes.PRIVATE_LIBRARY_MOVE_LESSON_RELEASE:
			return moveLesson(state, action)
		case actionTypes.PRIVATE_LIBRARY_MOVE_FOLDER_RELEASE:
			return moveFolder(state, action)
		case actionTypes.MY_LIBRARY_ADD_LESSON_TO_PRIVATE_LIBRARY_MODAL_FOLDER_ID_UPDATED:
			return updateFolderUID(state, action)
		default: return state
	}
}

export default privateLibraryReducer
